import { PATTERNS } from '../../constants/validations';
import { defaultValidator } from './defaultValidator';

export default value => {
  if (value) {
    const isValidEmail = defaultValidator(PATTERNS.EMAIL, value);
    const isValidPhone = defaultValidator(PATTERNS.PHONE_NUMBER, value);
    return isValidEmail || isValidPhone;
  }
};



// WEBPACK FOOTER //
// ./src/utils/validations/loginValidator.js